import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Roles, getRolesByCountryCode } from '../RoleConfig';
import { ProfileService } from '../../shared/profile.service';
import { map } from 'rxjs/operators';

@Component({
  selector: 'lp2-contact-us-picture',
  template: `
    <div class="main">
      <div class="container contact-us-page-container">
        <div class="page-title">
          <h2>{{ 'talkNow.whoTalkTo' | translate }}</h2>
        </div>
        <div class="row centered">
          <div *ngFor="let role of roles$ | async" class="col-6 profile-container">
            <lp2-contact-us-profile class="profile" [role]="role"></lp2-contact-us-profile>
          </div>
        </div>
      </div>
    </div>
  `,
  styleUrls: ['./contact-us-picture.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContactUsPictureComponent {
  constructor(private readonly profileService: ProfileService) {}

  public roles$ = this.profileService.address$.pipe(
    map(({ countryISO }) => getRolesByCountryCode(countryISO).filter((r) => r.role !== 'teacher'))
  );
}



// WEBPACK FOOTER //
// ./ts/app/contact-us/contact-us-picture/contact-us-picture.component.ts